import { Controller } from '@hotwired/stimulus';

// Only attached to the selected, active run. Reloading reads saved progress;
// it never starts a scan or repeats a linking request.
export default class extends Controller {
  connect() {
    this.timer = window.setTimeout(() => window.location.reload(), 10000);
  }

  disconnect() {
    window.clearTimeout(this.timer);
  }
}
